import { defineComponent as _defineComponent } from 'vue'
import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { BuilderDropdownOptionsEnum } from "@/enums/BuilderDropdownOptionsEnum";
  import { BuilderPackage } from "@/types/BuilderQuote";
  import { computed, ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderDropdown',
  props: {
    builders: {
      type: Array,
      default: () => [],
    },
    builderPackage: {
      type: Object,
      default: Object as () => BuilderPackage,
    },
  },
  emits: ["selectBuilder"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const selectedBuilderId = ref<string | null>(props.builderPackage.id || null);

  const builderSelected = computed(() => {
    const selectedBuilder = props.builders.find(
      (builder) => builder.id === selectedBuilderId.value
    );

    return (
      selectedBuilder || { title: BuilderDropdownOptionsEnum.SELECT_BUILDER }
    );
  });

  const emit = __emit;

  const onSelect = (builder: { title: string; id: string; logo: string }) => {
    selectedBuilderId.value = builder.id;
    emit("selectBuilder", builder.title, builder.id, builder.logo);
  };

const __returned__ = { props, selectedBuilderId, builderSelected, emit, onSelect, DropDown, get BuilderDropdownOptionsEnum() { return BuilderDropdownOptionsEnum }, get BuilderPackage() { return BuilderPackage }, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})